const activeOwners = new Set()
const lastRenderAtByOwner = new Map()
let lastRenderAtGlobal = 0

const ownerSharedScale = {
  avatar: 0.6,
  dice: 0.6
}

const nowMs = () => {
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    return performance.now()
  }
  return Date.now()
}

export function setRenderBudgetActive(owner, active) {
  if (!owner) return
  if (active) activeOwners.add(owner)
  else activeOwners.delete(owner)
}

export function canRenderWithBudget(owner, desiredFps = 30) {
  if (!owner) return true
  if (!activeOwners.has(owner)) return true

  const baseFps = Math.max(12, Number(desiredFps) || 30)
  const scale =
    activeOwners.size > 1 ? ownerSharedScale[owner] || ownerSharedScale.default || 0.6 : 1
  const targetFps = Math.max(12, Math.round(baseFps * scale))
  const minGap = 1000 / targetFps
  const now = nowMs()

  const lastOwnerAt = lastRenderAtByOwner.get(owner) || 0
  if (now - lastOwnerAt < minGap - 0.5) return false

  lastRenderAtByOwner.set(owner, now)
  lastRenderAtGlobal = now
  return true
}

export function getRenderBudgetState() {
  const owners = {}
  lastRenderAtByOwner.forEach((value, key) => {
    owners[key] = value
  })
  return {
    active: Array.from(activeOwners),
    lastRenderAtGlobal,
    lastRenderAtByOwner: owners
  }
}
